import { useRef } from "react";
import emailjs from "emailjs-com";

const CorporateMeditationForm = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "your_service_id",
        "your_template_id",
        form.current,
        "your_public_key"
      )
      .then(() => {
        alert("Message sent successfully!");
        form.current.reset();
      })
      .catch(() => {
        alert("Error sending message. Please try again.");
      });
  };

  return (
    <section className="bg-green-50 py-20 px-6">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-start">
        {/* Left Content */}
        <div data-aos="fade-right">
          <h2 className="text-sm text-green-700 font-semibold uppercase mb-2 tracking-wider">
            Don’t Know How To Connect With Us?
          </h2>
          <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6 leading-snug">
            Meditation for Organizations
          </h1>
          <p className="text-gray-700 mb-4 leading-relaxed">
            We offer free corporate meditation sessions — an exceptional solution for enhancing
            attention and mental clarity, mitigating stress and fatigue, and augmenting the
            happiness and productivity of employees.
          </p>
          <ul className="list-disc ml-6 text-gray-700 space-y-1 mb-6">
            <li>Individual self-empowerment</li>
            <li>Organizational performance</li>
            <li>Overall societal improvement</li>
          </ul>
          <p className="text-gray-700 mb-1">
            <strong>Phone:</strong> +91 94279 52027
          </p>
          <p className="text-gray-700">
            <strong>Email:</strong> nirmalsahaja.amd@gmail.com
          </p>
        </div>

        {/* Right Form */}
        <div
          className="bg-white rounded-2xl border border-green-100 p-8 shadow-md"
          data-aos="fade-left"
        >
          <h3 className="text-xl font-semibold text-green-800 mb-4 text-center">
            Free Meditation Session
          </h3>
          <form ref={form} onSubmit={sendEmail} className="space-y-4">
            <input
              name="user_name"
              type="text"
              placeholder="Enter your full name"
              required
              className="w-full border border-gray-300 px-4 py-3 rounded-lg focus:ring-2 focus:ring-green-600 focus:outline-none"
            />
            <input
              name="user_phone"
              type="text"
              placeholder="Phone number"
              required
              className="w-full border border-gray-300 px-4 py-3 rounded-lg focus:ring-2 focus:ring-green-600 focus:outline-none"
            />
            <input
              name="user_email"
              type="email"
              placeholder="Your email"
              required
              className="w-full border border-gray-300 px-4 py-3 rounded-lg focus:ring-2 focus:ring-green-600 focus:outline-none"
            />
            <input
              name="subject"
              type="text"
              placeholder="Short description"
              className="w-full border border-gray-300 px-4 py-3 rounded-lg focus:ring-2 focus:ring-green-600 focus:outline-none"
            />
            <textarea
              name="message"
              rows="4"
              placeholder="Your message"
              className="w-full border border-gray-300 px-4 py-3 rounded-lg focus:ring-2 focus:ring-green-600 focus:outline-none"
            ></textarea>
            <button
              type="submit"
              className="bg-green-700 text-white font-medium px-6 py-3 rounded-full hover:bg-green-800 transition w-full"
            >
              Send
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default CorporateMeditationForm;
